export default "__VITE_ASSET__CFr0wPpW__"